import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'
import { AppShell } from './layout/AppShell.js'
import { Katalog } from './pages/Katalog.js'
import { Konten } from './pages/Konten.js'
import { Kunde } from './pages/Kunde.js'
import { Kunden } from './pages/Kunden.js'
import { Unternehmen } from './pages/Unternehmen.js'
import { SitzungProvider } from './session/SitzungContext.js'
// Einziger Stil-Einstieg, gemeinsam mit der Kundenanwendung: Schriften,
// Untitled UI und die Marke in einer Kette (`packages/ui`).
import '@nac2s/ui/oberflaeche.css'

/**
 * Partner-Oberfläche.
 *
 * Sie spricht mit `apps/api` unter dem **Partner-Host** — die Kunden-Registry
 * liegt im Partner-Stack, nicht in der Verwaltung (`Projektstruktur.md` §2.4).
 *
 * **netable benutzt diese Oberfläche selbst.** Es gibt keinen internen
 * Sonderpfad daran vorbei (§1) — was hier fehlt, fehlt allen.
 *
 * Umfang laut §8, in dieser Reihenfolge: Kundenliste (hier), dann Anwender,
 * Geräte und Kopplungscodes, dann Seat-Cap, Edition und Admin-light-Stufe,
 * dann laufender Monats-Peak und Monatsreport. Das Anlegen eines Kunden kommt
 * zuletzt: Es hängt am Bereitstellungsarbeiter (securitytodo.md ST-027), denn
 * DDL gehört nicht in den Prozess, der Webanfragen bedient.
 */

const wurzel = document.getElementById('root')
if (!wurzel) throw new Error('Wurzelelement #root nicht gefunden')

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <SitzungProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<Kunden />} />
            {/* Eigene Adresse je Kunde — verlinkbar, mit Zurueckweg. Kein
                Aufklappen in der Liste. */}
            <Route path="kunden/:host" element={<Kunde />} />
            {/* Der Bereich steht jedem Angemeldeten offen; ob er etwas
                sieht, entscheidet der Server (403 ohne Recht). Die
                Navigation blendet ihn aus — das ist Bequemlichkeit,
                kein Schutz. */}
            <Route path="konten" element={<Konten />} />
            <Route path="katalog" element={<Katalog />} />
            <Route path="unternehmen" element={<Unternehmen />} />
            <Route path="*" element={<NichtGefunden />} />
          </Route>
        </Routes>
      </SitzungProvider>
    </BrowserRouter>
  </StrictMode>,
)

function NichtGefunden() {
  return (
    <div className="py-8">
      <h1 className="font-display text-xl font-bold text-primary">Seite nicht gefunden</h1>
      <p className="mt-2 text-sm text-tertiary">Diese Adresse gibt es nicht.</p>
    </div>
  )
}
